import dataProvider from "src/dataProvider";

const fetcher = dataProvider("adminInstance");

export interface MouUploadPayload {
  epid: string;
  documentKey: string;
  documentName?: string;
}

export interface MouUpdateDocumentPayload {
  mouId: string;
  documentKey: string;
  documentName?: string;
}

export interface MouSubmitPayload {
  mouId: string;
}

export interface MouReviewPayload {
  mouId: string;
  action: "APPROVE" | "QUERY";
  query?: string;
}

export interface MouQueryPayload {
  mouId: string;
  query: string;
}

export const uploadMou = async (data: MouUploadPayload) => {
  return fetcher.post<MouUploadPayload, any>("/mou/upload", data);
};

export const updateMouDocument = async (data: MouUpdateDocumentPayload) => {
  return fetcher.put<MouUpdateDocumentPayload, any>(
    "/mou/update-document",
    data
  );
};

export const submitMou = async (data: MouSubmitPayload) => {
  return fetcher.post<MouSubmitPayload, any>("/mou/submit", data);
};

export const getMouByEpid = async (epid: string) => {
  return fetcher.get<any>(`/mou/epid/${epid}`);
};

export const getMouQueries = async (mouId: string) => {
  return fetcher.get<any>(`/mou/queries/${mouId}`);
};

export const createMouQuery = async (data: MouQueryPayload) => {
  return fetcher.post<MouQueryPayload, any>("/mou/query", data);
};

export const reviewMou = async (data: MouReviewPayload) => {
  return fetcher.post<MouReviewPayload, any>("/mou/review", data);
};
